import type { ReactElement } from 'react';
import { resolveImagePath } from '@/utils/imageMap.ts';

interface AutoPaintingSectionProps {
  title: string;
  content: string;
  imageUrl: string;
  imageAlt?: string;
}

export function AutoPaintingSection({ 
  title, 
  content, 
  imageUrl,
  imageAlt = "Auto Painting and Refinishing Services"
}: AutoPaintingSectionProps): ReactElement {
  const resolvedImageUrl = resolveImagePath(imageUrl);

  return (
    <section className="py-16 md:py-20 bg-red-700">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Text Content */}
          <div className="text-white space-y-6">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold uppercase tracking-wide leading-tight">
              {title}
            </h2>
            <p className="text-base md:text-lg leading-relaxed opacity-95">
              {content}
            </p>
          </div>
          
          {/* Image */}
          <div className="relative">
            {resolvedImageUrl && (
              <div className="aspect-[4/3] w-full overflow-hidden rounded-lg shadow-2xl">
                <img
                  src={resolvedImageUrl}
                  alt={imageAlt}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}